import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AgentsQuestionsService } from '../services/agents-questions.service';
import { AgentsService } from 'core/services/agents.service';
import { Agent } from 'core/models/agent';
import { DynamicFormComponent } from 'core/components/forms/dynamic-form.component';
import { Client } from 'core/models';

@Component({
  selector: 'lms-agent-editor',
  templateUrl: './agent-editor.component.html',
  styleUrls: ['./agent-editor.component.scss']
})
export class AgentEditorComponent implements OnInit {
  @Input() agent: Agent;
  @Output() onSave = new EventEmitter<Agent>();
  @ViewChild(DynamicFormComponent, { static: false }) private dynamicForm: DynamicFormComponent;
  public questions: any[];
  private client: Client;

  constructor(
    public activatedRoute: ActivatedRoute,
    public agentsService: AgentsService,
    public agentsQuestions: AgentsQuestionsService
  ) {}

  public ngOnInit(): void {
    this.activatedRoute.data.subscribe((data) => {
      this.client = data.client;
      this.questions = this.agentsQuestions.getQuestions(this.agent, this.client);
    });
  }

  public ngOnChanges(changes: SimpleChanges): void {
    this.questions = this.agentsQuestions.getQuestions(changes['agent']['currentValue'], this.client);
  }

  public submit(agentData: any = {}): void {
    // TODO Why does dynamic form return null values as empty strings?
    if (agentData.distributorId === '') {
      agentData.distributorId = null;
    }

    if (this.agent && this.agent.id) {
      this.onUpdate(agentData);
    } else {
      this.onCreate(agentData);
    }
  }

  public onCreate(agentData: Object): void {
    this.agentsService
      .create(agentData)
      .then((agent) => {
        this.onSave.emit(agent);
        this.formSubmit(null);
      })
      .catch((err) => {
        this.formSubmit(err);
      });
  }

  public onUpdate(updatedData: Object): void {
    if (updatedData['clientIds'] === '') updatedData['clientIds'] = null;
    const tempAgent: Agent = Object.assign({}, this.agent, updatedData);
    this.agentsService
      .update(tempAgent)
      .then((updatedAgent) => {
        this.onSave.emit(updatedAgent);
        this.formSubmit(null);
      })
      .catch((err) => {
        this.formSubmit(err);
      });
  }

  private formSubmit(value): void {
    this.dynamicForm.submitted(value);
  }
}
